module.exports = {"230722100":"朝阳镇","230722101":"乌云镇","230722102":"乌拉嘎镇","230722103":"保兴镇","230722200":"常胜乡","230722201":"向阳乡","230722202":"沪嘉乡","230722203":"红光乡","230722205":"青山乡","230722400":"太平林场","230722402":"清河林场","230722404":"马连林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230722.json
// module id = 848
// module chunks = 0